/* eslint-disable no-undef */
<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">Datos del caso</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-row class="pr-5">
          <v-col cols="12" sm="12" md="12">
            <p>
              # Caso: <b>{{ datosCaso.caso }}</b>
            </p>
            <p>
              Departamento:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? datosCronos.departamento
                  : ciudad.departamento
              }}</b>
            </p>
            <p>
              Ciudad:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? datosCronos.ciudad
                  : datosCaso.ciudad_siniestro
              }}</b>
            </p>
            <p>
              Empresa:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? datosCronos.empresa
                  : empresa.empresa
              }}</b>
            </p>
            <p>
              Dirección siniestro:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? datosCronos.direccion
                  : datosCaso.direccion_siniestro
              }}</b>
            </p>
          </v-col>
          <v-card-title style="margin-left: 20px">
            <span class="headline">Datos del cliente</span>
          </v-card-title>
          <v-col cols="12" sm="12" md="12">
            <p>
              Nombre: <b>{{ conductor.nombres }} {{ conductor.apellidos }}</b>
              <v-badge
                color="info"
                :content="datosCaso.efectado"
                inline
              ></v-badge>
            </p>
            <p>
              Telefono: <b>{{ conductor.telefono }}</b>
            </p>
            <!-- <p>
              Dirección: <b>{{ conductor.direccion }}</b>
            </p> -->
          </v-col>
        </v-row>

        <v-card-text class="text--primary px-8"> </v-card-text>
        <v-card-actions class="pb-8 pl-8">
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "ModAddAsignar",
  data: () => ({
    loading: false,
    dialog: true,
    datosCaso: {},
    datosCronos: {},
    ciudad: {},
    empresa: {},
    conductor: {},
  }),
  created() {},
  props: {
    id: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        const datos = await db.collection("casos").doc(this.id).get();
        this.datosCaso = datos.data();
        const cronos = await db
          .collection("polizas")
          .where("caso", "==", this.datosCaso.caso)
          .get();
        const resultCronos = cronos.docs.map((e) => ({
          ...e.data(),
        }));
        this.datosCronos = resultCronos[0];
        const ciudad = await db
          .collection("ciudades")
          .doc(this.datosCaso.uidciudad)
          .get();
        this.ciudad = ciudad.data();
        const empresa = await db
          .collection("empresas")
          .doc(this.datosCaso.uidempresa)
          .get();
        this.empresa = empresa.data();
        const conductor = await db
          .collection("clientes")
          .doc(this.datosCaso.uidconductor)
          .get();
        this.conductor = conductor.data();
        this.datosCaso.efectado =
          this.datosCaso.uidconductor === this.datosCaso.uidcliente
            ? "Propietario"
            : "Conductor";
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
